import Tribute from 'tributejs'

class Mentions {
    constructor(options) {
        this.options = options
        this.collections = []

        this.input = this.findNode(this.options.input, '.has-mentions')
        this.http = { headers: [] }

        this.collect().attach()
    }

    findNode(selector, defaultSelector) {
        return document.querySelectorAll(selector || defaultSelector)
    }

    template(pool) {
        return (item) => `<span contenteditable="false">${item.original.mentions}</span>`
    }

    values(pool) {
        return (text, callback) => {
            if (text.length <= 1) return

            axios
                .get(`/api/forum/mentions?search=${text}&group_id=${this.options.group_id}`)
                .then((r) => {
                    callback(r.data.data.users)
                })
                .catch((e) => {
                    console.error(e)
                })
        }
    }

    collect() {
        for (let i = 0; i < this.options.pools.length; i++) {
            const pool = this.options.pools[i]
            this.collections.push({
                trigger: pool.trigger || '@',
                lookup: pool.display,
                allowSpaces: pool.allowSpaces || true,
                selectTemplate: this.template(pool),
                values: _.debounce(this.values(pool), 350)
            })
        }

        return this
    }

    attach() {
        this.tribute = new Tribute({
            collection: this.collections
        })

        this.tribute.attach(this.input)

        return this
    }
}

export default Mentions
